// eslint-disable-next-line import/prefer-default-export
export const REGEX = {
  NO_SPECIAL_CHARACTER: /^[A-Za-z0-9\s_]+$/,
  ONLY_NUMBER: /^[0-9]*$/,
};
